const _UTILS = {
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);
    
    observer.observe(node, config);  
    return observer;
  },
  ObserveMutation(selector, options, callback) {
    let observer = new MutationObserver(callback);

    // Notify me of everything!
    let observerConfig = {
      attributes: true, 
      childList: true, 
      characterData: true 
    };
    observerConfig = Object.assign(observerConfig, options);

    // Node, config
    // In this case we'll listen to all changes to body and child nodes
    var targetNodes = document.querySelectorAll(selector);
    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });  
  },
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('FAQ', () => ({
    search_q: '',
    faq_items: [],
    trending_items: [],
    init() {
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      let faq_items = JSON.parse(am.$el.dataset.blocks);
      let ids = JSON.parse(am.$el.dataset.blocksIds);
      faq_items.forEach((item, index) => {
        item.id = ids[index];
      });
      am.faq_items = [...faq_items];

      am.trending_items = [...faq_items.filter(item => item.trending)];
    },
    ShowFaq(block_id) {
      let am = this;
      if (!am.search_q) return true;
      let search_q = am.search_q.toLowerCase();

      let faq_item = am.faq_items.find(item => item.id == block_id);
      // console.log(am.faq_items, block_id)
      return faq_item.title.toLowerCase().indexOf(search_q) !== -1 || 
        faq_item.answer.toLowerCase().indexOf(search_q) !== -1;
    }
  }));

  Alpine.data('SearchForm', () => ({
    search_q: '',
    init() {
      this.InitWatchers()
    },
    InitWatchers() {
      let am = this;
      am.$watch('search_q', () => {
        am.$el.querySelector('.predictive-search__input').dispatchEvent(new CustomEvent('input', {bubbles: true}));
      });
    }
  }));

  Alpine.data('CollectionsButtons', () => ({
    init() {
      let am = this;
      let collection = am.$el.dataset.collection;
      am.$el.querySelectorAll('.button').forEach(($button) => {
        $button.classList.add('button--secondary');
        if ($button.href.indexOf(collection) == -1) {
          $button.classList.remove('button--primary');
        }
      });
    }
  }));

  Alpine.data('Sizebuttons', () => ({
    selected_sizes: [],
    init() {
      let am = this;
      let urlParams = new URLSearchParams(window.location.search);
      let sizes = Array.from(urlParams.getAll('filter.v.option.size'));
      // console.log(sizes)
      sizes.forEach(size => {
        let $size = am.$el.querySelector(`[data-size="${size}"]`);
        // console.log(size, $size)
        $size.classList.remove('button--secondary');
        $size.classList.add('button--primary');
      });
    },
    e_FilterBySize(e) {
      // console.log(e)
      let size = e.target.dataset.size;
      let $filter = document.querySelector(`[name="filter.v.option.size"][value="${size}"]`);
      if ($filter) {
        $filter.checked = true;
        $filter.dispatchEvent(new Event('change', {bubbles: true}));
      }
    }
  }));

  Alpine.data('FindYourSize', () => ({
    open_modal: false,
    init() {
    },
    e_OpenSizeModal() {
      let am = this;
      am.open_modal = true;
    }
  }));

  Alpine.data('SizeForm', () => ({
    toggle_button: 'in',
    input: {
      height: '',
      weight: '',
    },
    prompt_size: '',
    flags: {
      show_result: false
    },
    init() {
    },
    CalculateSize() {
      let am = this;
      let height = am.input.height;
      let weight = am.input.weight;
      if (!height || !weight) {
        am.flags.show_result = false;
        return;
      }

      if (am.toggle_button == 'cm') { 
        // convert cm to in
        height = height / 2.54;
        weight = weight / 0.453592;
      }

      if ((height > 58 && height <= 67) && (weight > 85 && weight <= 150)) {
        am.prompt_size = 'A';
      }
      else if ((height > 61 && height <= 71) && (weight > 105 && weight <= 165)) {
        am.prompt_size = 'B';
      }
      else if ((height > 59 && height <= 72) && (weight > 145 && weight <= 200)) { 
        am.prompt_size = 'Q';
      }
      else if ((height > 60 && height <= 72) && (weight > 175 && weight <= 240)) { 
        am.prompt_size = 'Q+';
      }
      am.flags.show_result = true;
    },
    e_CalculateSize() {
      let am = this;
      am.CalculateSize();
    }
  }));

  Alpine.data('QuickAddForm', () => ({
    open_modal: false,
    cache: {},
    handle: '',
    product: {},
    selected_variant: null,
    variant_media: null,
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {
      let am = this;
      am.handle = am.$el.dataset.handle;
      am.cache.$section = am.$el;
      am.cache.$form = am.$el.querySelector('.shopify-product-form');
      am.LoadProduct();
    },
    InitWatchers() {
      let am = this;
      document.addEventListener('variant:added', () => {
        am.open_modal = false;
      });
      am.$el.addEventListener('change', am.UpdateSelectedVariant.bind(am));
      am.$watch('selected_variant', () => {
        let $input_id = am.cache.$form.querySelector('input[name="id"]');
        $input_id.value = am.selected_variant.id;
        $input_id.dispatchEvent(new Event('change'));
        let product_media = am.product.media ? am.product.media[0] : null;
        am.variant_media = am.selected_variant.featured_media || product_media;
        // console.log(am.variant_media)
      });
    },
    async LoadProduct() {
      let am = this;
      let product = await fetch(`/products/${am.handle}.js`).then(res => res.json());
      am.product = product;
      am.UpdateSelectedVariant()
    },
    UpdateSelectedVariant() {
      let am = this;
      let selected = Array.from(am.$el.querySelectorAll('input:checked')).map($item => $item.value);
      if (selected.length) {
        am.selected_variant = am.product.variants.find(v => v.options.join('/') == selected.join('/'));
      }
      else {
        am.selected_variant = am.product.variants[0];
      }
      // console.log(this.selected_variant)
    },
    e_AddToCart() {
      let am = this;
      am.cache.$form.dispatchEvent(new Event('submit'));
    }
  }));

  Alpine.data('ProductShopURLAmazon', () => ({
    variants_urls: [],
    current_variant_id: '',
    current_variant_url: '',
    btn_text: 'Shop on Amazon',
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      am.variants_urls = JSON.parse(am.$el.dataset.variantsUrls);
      am.current_variant_id = am.$el.dataset.currentVariantId;
      am.current_variant_url = am.GetVariantURL();
    },
    InitWatchers() {
      let am = this;
      document.addEventListener('variant:changed', (e) => {
        am.current_variant_id = e.detail.variant.id;
        am.current_variant_url = am.GetVariantURL();
      });
    },
    GetVariantURL() {
      let am = this;
      let variant_id = am.current_variant_id;
      let variant = am.variants_urls.find(v => v.id == variant_id);
      if (variant.amazon_shop_url !== '') {
        am.btn_text = 'Shop on Amazon';
        return variant.amazon_shop_url
      }   
    }
  }));

  Alpine.data('ProductShopURLTarget', () => ({
    variants_urls: [],
    current_variant_id: '',
    current_variant_url: '',
    btn_text: 'Shop on Target',
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      am.variants_urls = JSON.parse(am.$el.dataset.variantsUrls);
      am.current_variant_id = am.$el.dataset.currentVariantId;
      am.current_variant_url = am.GetVariantURL();
    },
    InitWatchers() {
      let am = this;
      document.addEventListener('variant:changed', (e) => {
        am.current_variant_id = e.detail.variant.id;
        am.current_variant_url = am.GetVariantURL();
      });
    },
    GetVariantURL() {
      let am = this;
      let variant_id = am.current_variant_id;
      let variant = am.variants_urls.find(v => v.id == variant_id);
      if (variant.target_shop_url !== '') {
        am.btn_text = 'Shop on Target';
        return variant.target_shop_url
      }
    }
  }));

  Alpine.data('ProductShopURLWalmart', () => ({
    variants_urls: [],
    current_variant_id: '',
    current_variant_url: '',
    btn_text: 'Available Today at Walmart',
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      am.variants_urls = JSON.parse(am.$el.dataset.variantsUrls);
      am.current_variant_id = am.$el.dataset.currentVariantId;
      am.current_variant_url = am.GetVariantURL();
    },
    InitWatchers() {
      let am = this;
      document.addEventListener('variant:changed', (e) => {
        am.current_variant_id = e.detail.variant.id;
        am.current_variant_url = am.GetVariantURL();
      });
    },
    GetVariantURL() {
      let am = this;
      let variant_id = am.current_variant_id;
      let variant = am.variants_urls.find(v => v.id == variant_id);
      if (variant.walmart_shop_url !== '') {
        am.btn_text = 'Available Today at Walmart';
        return variant.walmart_shop_url;
      }       
    }
  }));
});